import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import smiley from '../images/smiley_face_V2-280.png';

class Loader extends React.Component {
  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="loader"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        {this.props.loading &&
          <div className="loader">
            <div className="loader__smiley">
              <img src={smiley} width={140} height={140} />
            </div>
          </div>}
      </ReactCSSTransitionGroup>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js